import { getUpgradeLinkProps } from '@anm/helpers/upgradeLink';
import { FC } from 'react';

import vtConfig from '../../../../../../config';
import HintLink from '../HintLink';

import { TabInfoWrapper } from './Wrapper';

type EmbedInfoProps = {
  shouldUpgrade: boolean;
  isPaymentFailed: boolean;
  isExtraEmbedsUsed: boolean;
  canPurchaseAboveLimit: boolean;
  embedLimit?: number;
  embeddedCount?: number;
  extraEmbedPrice?: number;
};

const { urls } = vtConfig();

const EmbedInfo: FC<EmbedInfoProps> = ({
  embedLimit,
  shouldUpgrade,
  embeddedCount,
  isPaymentFailed,
  extraEmbedPrice,
  isExtraEmbedsUsed,
  canPurchaseAboveLimit
}) => {
  const showUpgrade = !!(embedLimit && embeddedCount && embedLimit - embeddedCount <= 2);

  return (
    <TabInfoWrapper variant={showUpgrade ? 'warning' : 'normal'}>
      {(() => {
        switch (true) {
          case shouldUpgrade:
            return (
              <>
                You have reached your plan limits of {embedLimit} embedded videos. Please{' '}
                <a {...getUpgradeLinkProps(`${urls.wave}pricing/upgrade?period=annual&plan=Business`)}>upgrade</a> to
                unlock more embeds.
              </>
            );

          case isPaymentFailed:
            return (
              <>
                We were not able to process your payment. Please update{' '}
                <a href={`${urls.wave}subscription/editCard`}>your billing information</a> to unlock this feature.
              </>
            );

          case isExtraEmbedsUsed:
            return (
              <>
                You have opted-in to additional embeds. Your credit card will be charged an additional{' '}
                <b>{extraEmbedPrice}¢</b> per month for this video.
              </>
            );

          case canPurchaseAboveLimit:
            return (
              <>
                Your plan includes <b>{embedLimit}</b> embedded videos for free. You will be charged{' '}
                <b>{extraEmbedPrice}¢</b> per month for each additional video embed. <HintLink />
              </>
            );

          default:
            return (
              <>
                You are using <b>{embeddedCount}</b> out of <b>{embedLimit}</b> embedded videos.{' '}
                <HintLink {...{ showUpgrade }} />
              </>
            );
        }
      })()}
    </TabInfoWrapper>
  );
};

export default EmbedInfo;
